import React, { useState } from "react";
import cssClasses from "./SdrSelectModal.module.css";
import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../../Subcomponents/Button";
import DropDown from "../../../../Subcomponents/DropDown";
import { dismissLoader, presentLoader } from "../../../../Services/loader";
import { errorTost, successTost } from "../../../../Services/Toast";
import {
  updateAllotmentPayment,
  updateCrmAllotment,
} from "../../../../Services/AllAllotments";
import { bucketingForChangeUnit } from "../../../../Services/PaymentApi";

const SdrSelectModal = ({ open, handleClose, selectedAllotment }) => {
  const [selectedSdr, setSelectedSdr] = useState("");

  const submitHandler = (payload) => {
    presentLoader();
    updateAllotmentPayment(
      { unitCost: payload },
      selectedAllotment?.allotment_payment_id
    )
      .then((resp) => {
        updateCrmAllotment(
          {
            oldUnitCost: payload,
            sdrPercentage:
              selectedSdr === "7%" ? 7 : selectedSdr === "6%" ? 6 : 5,
          },
          selectedAllotment?.id
        )
          .then((val) => {
            let bucketingObj = {
              allotmentPaymentId: selectedAllotment?.allotment_payment_id,
            };
            bucketingForChangeUnit(bucketingObj)
              .then((v) => {
                handleClose();
                dismissLoader();
                successTost("SDR percentage updated successfully.");
              })
              .catch((error) => {
                dismissLoader();
                errorTost(error.message);
              });
          })
          .catch((e) => {
            handleClose();
            dismissLoader();
            errorTost(e.message);
          });
      })
      .catch((err) => {
        handleClose();
        dismissLoader();
        errorTost(err.message);
      });
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          <h1>Change SDR</h1>
          <IconButton
            className={cssClasses.crossButton}
            onClick={() => handleClose()}
          >
            {" "}
            <CloseIcon />{" "}
          </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
          <Box className={cssClasses.inputContainer}>
            <label style={{ fontSize: "1.5rem", fontFamily: "inter-semibold" }}>
              Select SDR%:
            </label>
            <DropDown
              onChangeSelect={(e) => {
                setSelectedSdr(e);
              }}
              selectedValue={selectedSdr}
              style={{
                selectedColor: "#175CD3",
                background: "#E8F0FE",
                minWidth: "200px",
              }}
              list={["7%", "6%", "5%"]}
            />
          </Box>
          <Box className={cssClasses.displayContainer}>
            <div
              style={{
                display: "flex",
                gap: "2rem",
                justifyContent: "space-between",
              }}
            >
              <span style={{ fontWeight: 600 }}>
                Old SDR ({selectedAllotment?.sdrpercentage}%) + Fee :
              </span>
              <span>
                ₹{numberWithCommas(selectedAllotment?.old_unit_cost?.sdr)}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                gap: "2rem",
                justifyContent: "space-between",
              }}
            >
              <span style={{ fontWeight: 600 }}>
                New SDR ({selectedSdr !== "" ? selectedSdr : "-"}) + Fee :
              </span>
              <span>
                {selectedSdr !== "" ? "₹" : ""}
                {selectedSdr !== ""
                  ? numberWithCommas(
                      Math.ceil(
                        ((Number(selectedAllotment?.old_unit_cost?.bsp) *
                          (selectedSdr === "7%"
                            ? 7
                            : selectedSdr === "6%"
                            ? 6
                            : 5)) /
                          100 +
                          (Number(selectedAllotment?.old_unit_cost?.bsp) / 100 >
                          30000
                            ? 30000
                            : Number(selectedAllotment?.old_unit_cost?.bsp) /
                              100) +
                          15000) /
                          100
                      ) * 100
                    )
                  : "-"}
              </span>
            </div>
          </Box>
        </div>

        <div className={cssClasses.footer}>
          <div>
            <Button
              style={{ color: "#344054", backgroundColor: "#ffffff" }}
              btnName={"Cancel"}
              clicked={() => handleClose()}
            />
          </div>
          <div>
            <Button
              style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
              btnName={"Submit"}
              disable={selectedSdr === ""}
              clicked={() => {
                const payload = {
                  bsp: Math.round(selectedAllotment?.old_unit_cost?.bsp),
                  sdr:
                    Math.ceil(
                      ((Number(selectedAllotment?.old_unit_cost?.bsp) *
                        (selectedSdr === "5%"
                          ? 5
                          : selectedSdr === "6%"
                          ? 6
                          : 7)) /
                        100 +
                        (Number(selectedAllotment?.old_unit_cost?.bsp) / 100 >
                        30000
                          ? 30000
                          : Number(selectedAllotment?.old_unit_cost?.bsp) /
                            100) +
                        15000) /
                        100
                    ) * 100,
                  gst: Math.round(
                    Number(selectedAllotment?.old_unit_cost?.bsp) < 4500000
                      ? Number(selectedAllotment?.old_unit_cost?.bsp) / 100
                      : (Number(selectedAllotment?.old_unit_cost?.bsp) * 5) /
                          100
                  ),
                  total: Math.round(
                    Number(selectedAllotment?.old_unit_cost?.bsp) +
                      Math.ceil(
                        ((Number(selectedAllotment?.old_unit_cost?.bsp) *
                          (selectedSdr === "5%"
                            ? 5
                            : selectedSdr === "6%"
                            ? 6
                            : 7)) /
                          100 +
                          (Number(selectedAllotment?.old_unit_cost?.bsp) / 100 >
                          30000
                            ? 30000
                            : Number(selectedAllotment?.old_unit_cost?.bsp) /
                              100) +
                          15000) /
                          100
                      ) *
                        100 +
                      (Number(selectedAllotment?.old_unit_cost?.bsp) < 4500000
                        ? Number(selectedAllotment?.old_unit_cost?.bsp) / 100
                        : (Number(selectedAllotment?.old_unit_cost?.bsp) * 5) /
                          100)
                  ),
                };
                submitHandler(payload);
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
};

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}

export default SdrSelectModal;
